import { Injectable } from '@angular/core';
import { Lookup } from '@common/utilities/Lookup';
import { CurrencyRecord, DataService } from './data.service';
import { SynchronizationService } from './synchronization.service';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class CurrenciesService {

  private lookupById = new Lookup<CurrencyRecord>(i => i.ID);
  private lookupBySymbol = new Lookup<CurrencyRecord>(i => i.Symbol);

  private _sync(notify: boolean = true) {

    if (notify) this.sync.notify(CurrenciesService, false);
    
    this.ds.currencies('list').subscribe(currencies => {

      if (currencies) {
        this.lookupById.source = currencies;
        this.lookupBySymbol.source = currencies;

        this.sync.notify(CurrenciesService, true);
      }
      else {
        if (this.api.authorized) {
          this._sync(false);
        }
        else {
          this.api.credentialChanged.subscribe(user => {
            this._sync(false);
          });
        }
      }
    });
  }

  public synchronize() {
    this._sync();
  }

  public get(idOrSymbol: number | string): CurrencyRecord {

    switch (typeof idOrSymbol) {
      case 'number': return this.lookupById.get(idOrSymbol, { ID: idOrSymbol as number, Symbol: '', Icon: '?', Conversion: 1, RoundingFactor: 0 });
      case 'string': return this.lookupBySymbol.get(idOrSymbol, { ID: 0, Symbol: idOrSymbol as string, Icon: '?', Conversion: 1, RoundingFactor: 0 });
      default: return { ID: 0, Symbol: '', Icon: '?', Conversion: 1, RoundingFactor: 0 };
    }    
  }

  constructor(private ds: DataService, private api: ApiService, private sync: SynchronizationService) {
    this._sync();
  }
}
